module.exports = __webpack_public_path__ + "img/Porto Apartment - 56 of 85.f37a8474.jpeg";